import { Phone, ShieldCheck, Star } from "iconoir-react"

export default function MobileDownload() {
  const appleLink = "https://apps.apple.com/us/app/vibrato-ai/id6746279853"
  const androidLink = "https://play.google.com/store/apps/details?id=com.getvibrato.mobile"

  return (
    <div className="h-fit flex flex-col items-center justify-center p-4 sm:p-6 lg:p-8">
      <div className="max-w-2xl w-full h-fit bg-white rounded-3xl shadow-2xl p-8">
        <div className="text-center mb-8">
          <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-r from-purple-600 to-indigo-600 rounded-xl flex items-center justify-center">
            <Phone className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-3">Take Vibrato Everywhere</h1>
          <p className="text-gray-600 leading-relaxed max-w-md mx-auto">
            Download the Vibrato AI mobile app for ultimate convenience. Make calls on-the-go, get instant
            notifications, and stay connected to your AI assistant.
          </p>
        </div>
        <div className="space-y-4 mb-8">
          <div className="flex items-center gap-3 p-3 bg-purple-50 rounded-lg">
            <div className="w-8 h-8 rounded-full bg-purple-600 flex items-center justify-center shrink-0">
              <Phone className="w-4 h-4 text-white" />
            </div>
            <span className="text-gray-800 font-medium">Make calls anywhere, anytime</span>
          </div>

          <div className="flex items-center gap-3 p-3 bg-blue-50 rounded-lg">
            <div className="w-8 h-8 rounded-full bg-blue-600 flex items-center justify-center shrink-0">
              <Star className="w-4 h-4 text-white" />
            </div>
            <span className="text-gray-800 font-medium">Get instant push notifications</span>
          </div>

          <div className="flex items-center gap-3 p-3 bg-green-50 rounded-lg">
            <div className="w-8 h-8 rounded-full bg-green-600 flex items-center justify-center shrink-0">
              <ShieldCheck className="w-4 h-4 text-white" />
            </div>
            <span className="text-gray-800 font-medium">Monitor calls live from your phone</span>
          </div>
        </div>
        <div className="space-y-4">
          <div className="text-center mb-4">
            <h4 className="text-lg font-semibold text-gray-900 mb-2">Download Now</h4>
            <p className="text-sm text-gray-600">Available on iOS and Android</p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            {/* iOS Download Button */}
            <a
              href={appleLink}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center hover:opacity-80 transition-opacity duration-200"
            >
              <img src="/ios-app-store.png" alt="Download on the App Store" className="h-12 w-auto" />
            </a>

            {/* Google Play Download Button */}
            <a
              href={androidLink}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center hover:opacity-80 transition-opacity duration-200"
            >
              <img src="/google-play.png" alt="Get it on Google Play" className="h-12 w-auto" />
            </a>
          </div>
        </div>
        <div className="mt-8 text-center">
          <p className="text-xs text-gray-500">
            Join thousands of users who have Vibrato on mobile for ultimate convenience.
          </p>
        </div>
      </div>
    </div>
  )
}
